import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

const ProgressLoader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  z-index: 999;

  background: ${({ theme, value }) =>
    `linear-gradient(to right, ${theme.colors.secondaryLight} ${value}%, ${theme.colors.white} ${value}%)`};
`

function PageLoader() {
  const [value, setValue] = useState(10)
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    if (value > 100) return setIsVisible(false)
    const eventLoader = setTimeout(() => {
      const randomValue = Math.floor(Math.random() * 7) + 1
      setValue((prev) => prev + randomValue)
    }, 100)

    return () => clearInterval(eventLoader)
  }, [value])

  return isVisible ? <ProgressLoader value={value} /> : null
}

export default PageLoader
